export default __webpack_public_path__ + "1c63f8d651d08bdc1e1f8a2a8251db2a.png";